import axios from 'axios';
import { ADMIN_ANALYTICS_ROUTE } from '../../api/backend';
import ClinicAuditActivityChartData from '../../common/model/type/clinic-audit-activity-chart-data.type';
import UserAuditActivityChartData from '../../common/model/type/user-audit-activity-chart-data.type';

export const getClinicAuditActivity = async (query: string) => {
  const { data } = await axios.get<ClinicAuditActivityChartData[]>(
    `/${ADMIN_ANALYTICS_ROUTE}/clinic-activities?${query}`
  );

  return data;
};

export const getUserAuditActivity = async (query: string) => {
  const { data } = await axios.get<UserAuditActivityChartData[]>(
    `/${ADMIN_ANALYTICS_ROUTE}/user-activities?${query}`
  );

  return data;
};
